<template>
  <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
  <div
    class="aha-right-nav"
    @mouseup.stop
    :class="{
      'powerpoint-addin-sticky': isEnableAddinPowerpoint && rightNavActiveTab
    }"
  >
    <div :data-tab-name="rightNavAllTabs.AI.name">
      <div
        class="right-nav__button"
        :class="{
          'active': rightNavActiveTab === rightNavAllTabs.AI.name,
          'disabled': isTabDisabled(rightNavAllTabs.AI.name),
        }"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: rightNavAllTabs.AI.name }"
        @click.stop="activeTab(rightNavAllTabs.AI.name)"
      >
        <aha-icon
          :name="rightNavAllTabs.AI.icon"
          :width="rightNavAllTabs.AI.iconWidth"
          :height="rightNavAllTabs.AI.iconHeight"
          :viewBox="rightNavAllTabs.AI.iconViewBox"
          class="right-nav__button-icon"
        ></aha-icon>
        <p class="right-nav__button-label" :lang="getPresenterLocale">
          {{ $i18nPresenter.t(rightNavAllTabs.AI.name) }}
        </p>
      </div>
    </div>

    <TemplateLibraryNavButton />

    <div class="right-nav__divider-wrapper">
      <div class="right-nav__divider"></div>
    </div>

    <div :data-tab-name="rightNavAllTabs.CONTENT.name">
      <div
        class="right-nav__button"
        :class="{
          'active': rightNavActiveTab === rightNavAllTabs.CONTENT.name,
          'disabled': isTabDisabled(rightNavAllTabs.CONTENT.name),
        }"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: rightNavAllTabs.CONTENT.name }"
        @click.stop="activeTab(rightNavAllTabs.CONTENT.name)"
      >
        <aha-icon
          :name="rightNavAllTabs.CONTENT.icon"
          :width="rightNavAllTabs.CONTENT.iconWidth"
          :height="rightNavAllTabs.CONTENT.iconHeight"
          :viewBox="rightNavAllTabs.CONTENT.iconViewBox"
          class="right-nav__button-icon"
        ></aha-icon>
        <p class="right-nav__button-label" :lang="getPresenterLocale">
          {{ $i18nPresenter.t(rightNavAllTabs.CONTENT.name) }}
        </p>
      </div>
    </div>
    <div :data-tab-name="rightNavAllTabs.DESIGN.name">
      <div
        class="right-nav__button"
        :class="{
          'active': rightNavActiveTab === rightNavAllTabs.DESIGN.name,
          'disabled': isTabDisabled(rightNavAllTabs.DESIGN.name),
        }"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: rightNavAllTabs.DESIGN.name }"
        @click.stop="activeTab(rightNavAllTabs.DESIGN.name)"
      >
        <aha-icon
          :name="rightNavAllTabs.DESIGN.icon"
          :width="rightNavAllTabs.DESIGN.iconWidth"
          :height="rightNavAllTabs.DESIGN.iconHeight"
          :viewBox="rightNavAllTabs.DESIGN.iconViewBox"
          class="right-nav__button-icon"
        ></aha-icon>
        <p class="right-nav__button-label" :lang="getPresenterLocale">
          {{ $i18nPresenter.t(rightNavAllTabs.DESIGN.name) }}
        </p>
      </div>
    </div>
    <div :data-tab-name="rightNavAllTabs.AUDIO.name">
      <div
        class="right-nav__button"
        :class="{
          'active': rightNavActiveTab === rightNavAllTabs.AUDIO.name,
          'disabled': isTabDisabled(rightNavAllTabs.AUDIO.name),
        }"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: rightNavAllTabs.AUDIO.name }"
        @click.stop="activeTab(rightNavAllTabs.AUDIO.name)"
      >
        <aha-icon
          :name="rightNavAllTabs.AUDIO.icon"
          :width="rightNavAllTabs.AUDIO.iconWidth"
          :height="rightNavAllTabs.AUDIO.iconHeight"
          :viewBox="rightNavAllTabs.AUDIO.iconViewBox"
          class="right-nav__button-icon"
        ></aha-icon>
        <p class="right-nav__button-label" :lang="getPresenterLocale">
          {{ $i18nPresenter.t(rightNavAllTabs.AUDIO.name) }}
        </p>
      </div>
    </div>

    <div class="right-nav__divider-wrapper">
      <div class="right-nav__divider"></div>
    </div>

    <div :data-tab-name="rightNavAllTabs.SETTINGS.name">
      <div
        class="right-nav__button"
        :class="{
          'active': rightNavActiveTab === rightNavAllTabs.SETTINGS.name,
          'disabled': isTabDisabled(rightNavAllTabs.SETTINGS.name),
        }"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: rightNavAllTabs.SETTINGS.name }"
        @click.stop="activeTab(rightNavAllTabs.SETTINGS.name)"
      >
        <aha-icon
          :name="rightNavAllTabs.SETTINGS.icon"
          :width="rightNavAllTabs.SETTINGS.iconWidth"
          :height="rightNavAllTabs.SETTINGS.iconHeight"
          :viewBox="rightNavAllTabs.SETTINGS.iconViewBox"
          class="right-nav__button-icon"
        ></aha-icon>
        <p class="right-nav__button-label" :lang="getPresenterLocale">
          {{ $i18nPresenter.t(rightNavAllTabs.SETTINGS.name) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// This component is a temporary solution for the Template Library in Editor
// (https://ahaslides.atlassian.net/browse/AHA-29321). It will be removed soon. Please do not use it.
//
// **Related Issue:**
// Template Library in Editor
// (https://ahaslides.atlassian.net/browse/AHA-29321)
//
// **Feature Flag:**
// release-template-library-in-editor
//
// **Removal Conditions:**
// - The refactor task is completed (https://ahaslides.atlassian.net/browse/AHA-29948).
//
// TODO: Remove this file once all the above conditions are met.

import RightNav from './RightNav.vue'
import TemplateLibraryNavButton from '@/components-v2/template-library/v2/TemplateLibraryNavButton.vue'

export default {
  components: {
    TemplateLibraryNavButton,
  },
  extends: RightNav,
}
</script>
